import {database} from "../firebase";

export default database;
